var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6002 3.19995C8.71654 3.19995 8.0002 3.9163 8.0002 4.79995H24.0002C24.0002 3.9163 23.2838 3.19995 22.4002 3.19995H9.6002ZM3.2002 9.59995C3.2002 7.83264 4.63288 6.39995 6.4002 6.39995H25.6002C27.3675 6.39995 28.8002 7.83264 28.8002 9.59995V25.6C28.8002 27.3673 27.3675 28.8 25.6002 28.8H6.4002C4.63288 28.8 3.2002 27.3673 3.2002 25.6V9.59995ZM15.543 19.7343V13.6689C15.543 13.2845 15.7836 12.9411 16.1449 12.8097L19.3449 11.646C19.9412 11.4292 20.5716 11.8708 20.5716 12.5053V14.2235C20.5716 14.6046 20.3352 14.9457 19.9784 15.0796L17.2111 16.1173C17.0327 16.1842 16.9145 16.3548 16.9145 16.5453V21.7142C16.9145 22.9766 15.6865 24 14.1716 24C12.6568 24 11.4288 22.9766 11.4288 21.7142C11.4288 20.4519 12.6568 19.4285 14.1716 19.4285C14.6712 19.4285 15.1396 19.5398 15.543 19.7343Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicAlbum);
export default __webpack_public_path__ + "static/media/music-album.ed9857ca226d6c875c5ec05e90d3215a.svg";
export { ForwardRef as ReactComponent };